<template>
    <rd-column :size="$columns.SixOnLg">
        <rd-card type="vertical" margins="none">
            <rd-card-header>
                <rd-header :title="$t('dashboard.substitutions.title')" margins="none" size="medium" />
            </rd-card-header>
            <rd-card-content>
                <dx-list :data-source="substitutions"
                         :focus-state-enabled="false"
                         :active-state-enabled="false"
                         height="200"
                         ref="substitutionList">
                    <template #item="{ data: item }">
                        {{item.SubstituteName}} {{$t('dashboard.substitutions.replaces')}} {{item.ReplacedName}}
                    </template>
                </dx-list>
            </rd-card-content>
        </rd-card>
    </rd-column>
</template>

<script>
    // @ is an alias to /src
    import { mapState, mapActions } from 'vuex';
    import commonMessages from '../../locales';
    import localMessages from '../locales';
    import DxList from 'devextreme-vue/list';

    const name = "processesStores/pzzDashboardStores/indexStore";

    export default {
        name: 'pzzSubstitutions',
        computed: {
            ...mapState(name, ['substitutions'])
        },
        methods: {
            ...mapActions(name, ['setSubstitutions'])
        },
        mounted() {
            this.setSubstitutions();
            //this.interval = setInterval(() => this.$refs.substitutionList.instance.repaint(), 10 * 1000);
            //this.interval = setInterval(() => this.$forceUpdate(), 60 * 1000);
        },
        components: {
            DxList
        },
        i18n: {
            messages: localMessages.messages,
            sharedMessages: commonMessages.messages
        }
    }
</script>
